// Copyright (c) 2022 by Move Closer

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export const MARGIN_BETWEEN_SLIDE = 24
export const SLIDE_VIEWPORT_WIDTH_RATIO = 0.75
export const SLIDES_CONTAINER_SELECTOR = '.slides'
